import { graphql } from 'gatsby';

export default function handleUnspecifiedProducer(product) {
  const shouldUseExhibitorAsProducer = hasUnspecifiedProducer(product);
  return shouldUseExhibitorAsProducer
    ? {
        ...product,
        producer: {
          ...product.registration.profile,
          // This is required for EventProductPageHeader so that it links to exhibitors detail page
          exhibitorId: product.registration.companyId,
          // This is required so that the names are not repeated.
          producerId: product.registration.companyId,
          // This is to simplify the logic in EventProductPageHeader
          isUnspecifiedProducerReplaced: true,
        },
      }
    : product;
}

/**
 *
 * @param {{producer?:{producerId: string}}} product
 * @returns
 */
export function hasUnspecifiedProducer(product) {
  return (
    !product.producer ||
    product.producer.producerId === '500000000000000000000000'
  );
}

export const fragment = graphql`
  fragment Bottlebooks_UnspecifiedProducer on Bottlebooks_RegisteredProduct {
    product {
      producer {
        name
        producerId
      }
    }
    registration {
      companyId
      profile {
        name
        city
        countryCode: country(format: RAW)
        countryName: country
        logo {
          publicId
        }
      }
    }
  }
`;
